import { render, staticRenderFns } from "./TaskWorkflowDeleted.vue?vue&type=template&id=168875fc&scoped=true"
import script from "./TaskWorkflowDeleted.vue?vue&type=script&lang=js"
export * from "./TaskWorkflowDeleted.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168875fc",
  null
  
)

export default component.exports